import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { shadowAiRows } from '../../data/mockBackedAdapters'
import { MOCK_BACKED_AREAS, buildMockGap } from '../../data/reportModel'
import MockedPanel from '../../components/MockedPanel/MockedPanel'
import ReportTable from '../../components/ReportTable/ReportTable'
import SubBlock from '../../components/SubBlock/SubBlock'

export default function ShadowAi({ dataAvailability }) {
  const columns = [
    {
      key: 'tool',
      header: <FormattedMessage id="AI_RISK_REPORT.COL.APPLICATION" />,
      render: (row) => <span className="text-body fw-bold">{row.label}</span>,
      sortable: true,
      sortValue: (row) => row.label,
    },
    {
      key: 'users',
      header: <FormattedMessage id="AI_RISK_REPORT.COL.USER" />,
      render: (row) => row.users,
      sortable: true,
      sortValue: (row) => row.users ?? 0,
    },
  ]

  return (
    <SubBlock
      titleId="AI_RISK_REPORT.THIRD.SHADOW_AI.TITLE"
      subtitleId="AI_RISK_REPORT.THIRD.SHADOW_AI.SUBTITLE"
      mocked
      hideFromExport
    >
      <MockedPanel gap={buildMockGap(dataAvailability, MOCK_BACKED_AREAS.SHADOW_AI)}>
        <ReportTable columns={columns} rows={shadowAiRows} />
      </MockedPanel>
    </SubBlock>
  )
}

ShadowAi.propTypes = { dataAvailability: PropTypes.arrayOf(PropTypes.shape({})).isRequired }
